export interface LoginUserModelI {
  password: string;
  username: string;
}

/**
 * Model for an admin login
 */
export class LoginUserModel implements LoginUserModelI {
  password = "";
  username = "";
}
